<template>
  <v-theme-provider dark>
    <base-section id="social" class="blue darken-4 text-center" space="56">
      <base-icon class="mb-8">
        mdi-facebook
      </base-icon>

      <base-section-heading color="transparent" title="Social Media">
        We're on social media and we'd love you to give us a follow ! <br />
        Stay connected with Maritec Software Service! Choose your favourite
        social media channel
      </base-section-heading>

      <div class="py-4" />

      <v-btn
        class="font-weight-bold"
        color="white"
        href="https://x.com/maritechone"
        light
        min-width="168"
        target="_blank"
        x-large
      >
        Follow Us

        <v-icon right>
          mdi-twitter
        </v-icon>
      </v-btn>
      &nbsp; &nbsp;
      <v-btn
        class="font-weight-bold"
        color="white"
        href="https://www.linkedin.com/company/maritech-software"
        light
        min-width="168"
        target="_blank"
        x-large
      >
        Follow Us

        <v-icon right>
          mdi-linkedin
        </v-icon>
      </v-btn>
    </base-section>
  </v-theme-provider>
</template>

<script>
export default {
  name: "SectionNews",

  provide: {
    heading: { align: "center" }
  }
};
</script>
